var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "sop-virtual-hbl",
      attrs: {
        "custom-class": "business-info-dialog",
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        width: "90%"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          _vm.innerVisible = false
        }
      }
    },
    [
      _c("sop-virtual-hbl-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "sopVirtualHblWorkspace",
        attrs: { "parent-context": _vm.context },
        on: {
          instructionCallback: _vm.instructionCallback,
          close: function($event) {
            _vm.innerVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }